import { ConversationModel } from "../schema/conversation.model";
import { MongoBaseContainer } from "./mongo-base-container.model";

export class ConversationContainer extends MongoBaseContainer{
    conversation: ConversationModel;
}